import Siema from 'siema';

const carousel = $('.js-carousel');
const productCarousel = document.querySelector('.js-carousel_products');
const numberedCarousel = document.querySelector('.js-carousel_numbered');
const navNextSlide = document.querySelector('.js-carousel-navNext');
const navPrevSlide = document.querySelector('.js-carousel-navPrev');

carousel.each(function(){
    class SiemaCarousel extends Siema {
        // extend a Siema class by two methods
        // addDots - to create a markup for dots
        // updateDots - to update classes on dots on change callback
        addDots () {
            // create a contnier for all dots
            // add a class 'dots' for styling reason
            this.dots = document.createElement('div');
            this.dots.classList.add('carousel-dots');

            // loop through slides to create a number of dots
            for(let i = 0; i < this.innerElements.length; i++) {
                // create a dot
                const dot = document.createElement('div');
                let dotImg = '';

                // add a class to dot
                dot.classList.add('carousel-dots-item');

                if (this.innerElements[i].getElementsByTagName('img')[0]) {
                    const slideImg = this.innerElements[i].getElementsByTagName('img')[0].getAttribute("src");
                    const slideImgAlt = this.innerElements[i].getElementsByTagName('img')[0].getAttribute("alt");
                    dotImg = '<img src="'+ slideImg +'" alt="'+ slideImgAlt +'" />'

                }
                else if (this.innerElements[i].getElementsByTagName('video')[0]) {
                    const videoImg = this.innerElements[i].getElementsByTagName('video')[0].getAttribute("thumbnail");
                    dotImg = '<img src="'+ videoImg +'" alt="Video Thumbnail" /><span class="productHeroPlayIcon productHeroPlayIcon_thumb"></span>';
                }

                if (window.screen.width >= 1024) {
                    // add img element to dot
                    dot.innerHTML = dotImg;
                }

                // add an event handler to each of them
                dot.addEventListener('click', () => {
                    this.goTo(i);
                })

                // append dot to a container for all of them
                this.dots.appendChild(dot);
            }

            // add the container full of dots after selector
            this.selector.parentNode.parentNode.append(this.dots);
        }

        updateDots () {
            // loop through all dots
            for(let i = 0; i < this.dots.querySelectorAll('.carousel-dots-item').length; i++) {
                // if current dot matches currentSlide prop, add a class to it, remove otherwise
                const addOrRemove = this.currentSlide === i ? 'add' : 'remove';
                this.dots.querySelectorAll('.carousel-dots-item')[i].classList[addOrRemove]('isCurrent');
            }
        }

        addNumbers () {
            this.numberContainer = document.createElement('div');
            this.currentNumberElement = document.createElement('div');
            this.totalNumberElement = document.createElement('div');

            this.numberContainer.classList.add('carousel-numbers');
            this.currentNumberElement.classList.add('carousel-numbers-current');
            this.totalNumberElement.classList.add('carousel-numbers-total');

            this.currentNumberElement.innerHTML = this.currentSlide + 1;
            this.totalNumberElement.innerHTML = this.innerElements.length;

            this.numberContainer.append(this.currentNumberElement);
            this.numberContainer.append(this.totalNumberElement);

            this.selector.parentNode.insertBefore(this.numberContainer, this.selector.nextSibling);
        }

        addPrevNext () {
                this.navContainer = document.createElement('div');
                this.nextElement = document.createElement('div');
                this.prevElement = document.createElement('div');

                this.navContainer.classList.add('carousel-nav','carousel-nav_alt');
                this.prevElement.classList.add('carousel-nav-prev', 'js-carousel-navPrev');
                this.nextElement.classList.add('carousel-nav-next', 'js-carousel-navNext')

                this.navContainer.append(this.prevElement);
                this.navContainer.append(this.nextElement);

                this.selector.parentNode.insertBefore(this.navContainer, this.selector.nextSibling);

                this.prevElement.addEventListener('click', () => spdcCarousel.prev());
                this.nextElement.addEventListener('click', () => spdcCarousel.next());
        }

        updateNumbers () {
            this.currentNumberElement.innerHTML = this.currentSlide + 1;
        }

        pauseCarouselVideos() {
            const carouselVideos = document.querySelectorAll('.js-video--container');

            carouselVideos.forEach(function(videoElement){
                var playButton = videoElement.querySelector(".js-video--play");
                var video = videoElement.querySelector(".js-video--element");

                video.pause();
                playButton.innerHTML = "Play";
                playButton.classList.remove('isPlaying');
            });
        }

        keyNavigation () {
            window.addEventListener("keydown", e => {
                switch(e.key) {
                    case 'ArrowLeft':
                        this.prev()
                    break;
                    case 'ArrowRight':
                        this.next()
                    break;
                }
            });
        }
    }

    const spdcCarousel = new SiemaCarousel({
        selector: '.js-carousel',
        loop: 'true',
        duration: '500',
        easing: 'ease-in-out',
        onChange: onChangeCallback,
        onInit: function(){
            if (this.innerElements.length > 1) {
                if (numberedCarousel) {
                    this.addNumbers();
                    this.addPrevNext();
                }
                if (productCarousel) {
                    this.addDots();
                    this.updateDots();
                }
                this.keyNavigation();
            };
        },

    });

    function onChangeCallback() {
        if (!productCarousel || this.innerElements.length <= 1) {
            return;
        }
        if (numberedCarousel) {
            this.updateNumbers();
        } else {
            this.updateDots()
        }
        this.pauseCarouselVideos()
    }

    if (navNextSlide == null || navPrevSlide == null) {
        return;
    }
    navPrevSlide.addEventListener('click', () => spdcCarousel.prev());
    navNextSlide.addEventListener('click', () => spdcCarousel.next());
    // setInterval(() => spdcCarousel.next(), 5000);
    // navPrevSlide.addEventListener('keydown', () => spdcCarousel.prev());
});